const React = require('react');
const PropTypes = require('prop-types');
const { wrapFunctionalComponent } = require('utils/framework').default;
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const { compose, color, space, system } = require('styled-system');
const theme = require('style/theme');

const PATHS = require('components/Icon/paths');

const size = system({
    size: {
        property: 'fontSize',
        scale: 'fontSizes'
    }
});

const StyledSvg = getStyledComponent({
    InnerComp: getBaseComponent({ elementType: 'svg' }),
    styledProps: [
        props => [
            {
                display: 'inline-block',
                width: '1em',
                height: '1em',
                position: 'relative',
                verticalAlign: 'text-bottom',
                fill: 'currentColor',
                flexShrink: 0
            },
            compose(color, space, size),
            props.css
        ]
    ]
});

function Icon({ name, ...props }) {
    return (
        <StyledSvg
            viewBox='0 0 24 24'
            {...props}
        >
            {PATHS[name]}
        </StyledSvg>
    );
}

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
    ['aria-hidden']: PropTypes.oneOf([true, null])
};

Icon.defaultProps = {
    theme,
    size: 24,
    ['aria-hidden']: true
};

module.exports = wrapFunctionalComponent(Icon, 'Icon');
